import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { apiService } from 'src/app/service/api.service';
import { ValidacionService } from 'src/app/service/validacion.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-evaluacion-confidencial',
  templateUrl: './modal-evaluacion-confidencial.component.html',
  styleUrls: ['./modal-evaluacion-confidencial.component.css']
})
export class ModalEvaluacionConfidencialComponent implements OnInit {

  jardineSelected;

 evaluacionFormGroup = new FormGroup({
    respuesta1: new FormControl(''),
    respuesta2: new FormControl(''),
    respuesta3: new FormControl(''),
    respuesta4: new FormControl(''),
    respuesta5: new FormControl(''),
    respuesta6: new FormControl(''),
    respuesta7: new FormControl(''),
    respuesta8: new FormControl(''),
    respuesta9: new FormControl(''),
    respuesta10: new FormControl(''),
    nombreDirectora: new FormControl(''),
    observacion: new FormControl(''),
  });

  buttonEnviarEvaluacion:boolean=true;

  constructor(private modal: NgbModal,  public dialogRef: MatDialogRef<ModalEvaluacionConfidencialComponent>,
    private validacionService: ValidacionService,
    private api: apiService) { }

  ngOnInit(): void {
    this.getActa();
    this.getEvaluacion();
    this.getEstadoEvaluacion();
    this.getDirectora();
    }

  closeModal(){
    this.dialogRef.close()
  }
  
  getActa(){
    this.jardineSelected = this.api.dataJardin
  }


  getEstadoEvaluacion(){
    const param = this.api.dataJardin.idJardinPeriodo
      this.validacionService.API_POST_getEstadoValidacion(param).subscribe((response: any) => {   
      },
      (err) => {
        console.log("error"+err)
      });
    }


    crearEvaluacionValidacion(){
      const param = this.api.dataJardin.idJardinPeriodo

      const paramData = {

         idJardinPeriodo:param,
         nota1: this.evaluacionFormGroup.get('respuesta1').value,   
         nota2: this.evaluacionFormGroup.get('respuesta2').value,    
         nota3: this.evaluacionFormGroup.get('respuesta3').value,   
         nota4: this.evaluacionFormGroup.get('respuesta4').value,     
         nota5: this.evaluacionFormGroup.get('respuesta5').value,      
         nota6: this.evaluacionFormGroup.get('respuesta6').value,       
         nota7: this.evaluacionFormGroup.get('respuesta7').value,       
         nota8: this.evaluacionFormGroup.get('respuesta8').value,   
         nota9: this.evaluacionFormGroup.get('respuesta9').value,  
         nota10: this.evaluacionFormGroup.get('respuesta10').value,
         observacion:this.evaluacionFormGroup.get('observacion').value,

      }

        this.validacionService.API_POST_crearEvaluacionValidacion(param, Object.assign(paramData)).subscribe((response: any) => {   
          Swal.fire({
            title: 'Listo',
            text: 'Evaluación creada correctamente',
            icon: 'success',
            confirmButtonText: 'OK'
          })
          this.dialogRef.close()
      
        },
        (err) => {
          console.log("error"+err)
        });
      }
  

      getDirectora(){
        const param = this.api.dataJardin.id
        this.api.API_POST_obtenerDirectora(param).subscribe((response) => {
          this.evaluacionFormGroup.get('nombreDirectora').setValue(response.payload.nombreDirectora);    
        },
        (err) => {
          console.log(err)
        })
      }

      getEvaluacion(){
        const param = this.api.dataJardin.idJardinPeriodo
        this.validacionService.API_POST_getEvaluacionValidacion(param).subscribe((response: any) => {

          if(response.payload.nota1 === null && response.payload.nota2 === null && response.payload.nota3 === null){
            return
          } 

          this.evaluacionFormGroup.get('respuesta1').setValue(response.payload.nota1.toString())   
          this.evaluacionFormGroup.get('respuesta2').setValue(response.payload.nota2.toString())    
          this.evaluacionFormGroup.get('respuesta3').setValue(response.payload.nota3.toString())   
          this.evaluacionFormGroup.get('respuesta4').setValue(response.payload.nota4.toString())     
          this.evaluacionFormGroup.get('respuesta5').setValue(response.payload.nota5.toString())     
          this.evaluacionFormGroup.get('respuesta6').setValue(response.payload.nota6.toString())       
          this.evaluacionFormGroup.get('respuesta7').setValue(response.payload.nota7.toString())      
          this.evaluacionFormGroup.get('respuesta8').setValue(response.payload.nota8.toString())
          this.evaluacionFormGroup.get('respuesta9').setValue(response.payload.nota9.toString())
          this.evaluacionFormGroup.get('respuesta10').setValue(response.payload.nota10.toString())
          this.evaluacionFormGroup.get('observacion').setValue(response.payload.observacion)
          this.buttonEnviarEvaluacion = false;
          this.evaluacionFormGroup.disable()
          },
        (err) => {
          console.log("error"+err)
        });
      
      }
    

}
